import { render, staticRenderFns } from "./shipperDetail.vue?vue&type=template&id=9ecb399e&scoped=true"
import script from "./shipperDetail.vue?vue&type=script&lang=js"
export * from "./shipperDetail.vue?vue&type=script&lang=js"
import style0 from "./shipperDetail.vue?vue&type=style&index=0&id=9ecb399e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ecb399e",
  null
  
)

export default component.exports